import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink } from "react-router-dom";
import useFetchApiData from "../helper/useFetchApiData";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form } from 'formik';
import Logout from "./Logout";
import { useSearchParams,useParams } from "react-router-dom";

const HeaderOne = () => {
  const categories = useFetchApiData("/categories");
  const [categoriesWithSub, setCategoriesWithSub] = useState([]);
  console.log(categories);

  const [cartCount, setCartCount] = useState(0);
  const [search, setSearch] = useState("");
  const [categoryId, setCategoryId] = useState(1);  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { cat_id } = useParams(); // Get category ID from URL path

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the form from reloading the page

    // Construct the URL with the selected category ID and search term
    const url = `/shop/${categoryId}?search=${encodeURIComponent(search)}`;

    // Navigate to the constructed URL
    navigate(url);
  };

  // Function to get the cart count from localStorage
  const updateCartCount = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const count = cart.reduce((acc, item) => acc + (item.qty || 0), 0);
    setCartCount(count);
  };

  useEffect(() => {
     

    updateCartCount();

     
    const handleCartUpdate = () => {
      updateCartCount();
    };

    window.addEventListener("cartUpdated", handleCartUpdate);

    
    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  async function getSubCategories(id) {
    const domain = `${process.env.REACT_APP_BACKEND_URI}/categories/childes/${id}`;
    try {
      const response = await axios.get(domain);

      return response.data; // Return the data
    } catch (error) {
      console.error("Error fetching subcategories", error);
      return []; // Return an empty array on error
    }
  }

  async function getCatData() {
    const updatedCategories = await Promise.all(
      categories.map(async (category) => ({
        ...category,
        subcategory: await getSubCategories(category.id), // Await the result
      }))
    );

    setCategoriesWithSub(updatedCategories); // Update the state
  }

  useEffect(() => {
    if (categories.length > 0) {
      getCatData(); // Fetch subcategories for each category
    }
  }, [categories]);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);
 
  const initialCategory = cat_id || '1';
  const initialSearch = searchParams.get('search') || '';
  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/* ==================== Search Box Start Here ==================== */}
      <form action="#" className={`search-box ${activeSearch && "active"}`}>
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for a product or brand"
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>
      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src="https://i.ibb.co/VtYZ856/logo.png" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              {/* Home Menu */}
              <li
                onClick={() => handleMenuClick(0)}
                className={`on-hover-item nav-menu__item ${
                  activeIndex === 0 ? "d-block" : ""
                }`}
              >
                <Link to="#" className="nav-menu__link">
                  Home
                </Link>
              </li>

              {/* Shop Menu */}

              {/* Contact Us Menu */}
              <li className="nav-menu__item">
                <Link
                  to="/contact"
                  className="nav-menu__link"
                  onClick={() => setActiveIndex(null)}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Top Start ========================= */}
      <div className="header-top bg-main-600 flex-between">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              <li className="border-right-item">
                <Link
                  to="/about-us"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  About us
                </Link>
              </li>
              <li className="border-right-item">
                <Link
                  to="/terms-and-conditions"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Terms & Condition
                </Link>
              </li>
              <li className="border-right-item">
                <Link
                  to="/return-policy"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Returns Policy
                </Link>
              </li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              <li className="border-right-item">
                <Link
                  to={
                    localStorage.getItem("accessToken")
                      ? "/profile-page"
                      : "/login"
                  }
                  className="text-white text-sm py-8 flex-align gap-6"
                >
                  <span className="icon text-md d-flex">
                    {" "}
                    <i className="ph ph-user-circle" />{" "}
                  </span>
                  <span className="hover-text-decoration-underline">
                    {localStorage.getItem("accessToken") ? (
                      <>My Account</>
                    ) : (
                      <>Login to Gharbar</>
                    )}
                  </span>
                  {" "}
                  <button className="mx-20 hover-text-decoration-underline" onClick={Logout}>
                    {localStorage.getItem("accessToken") ? (
                      <>  <span className="text-white">
                      {" "}
                      <i className="ph ph-sign-out" />{" "}Logout
                    </span>{" "}</>
                    ) : (
                      <> </>
                    )}
                  </button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start ========================= */}
      <header className="header-middle bg-color-one border-bottom border-gray-100">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img src="https://i.ibb.co/VtYZ856/logo.png" alt="Logo" />
              </Link>
            </div>
            {/* Logo End  */}
            {/* form location Start */}
            <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
            <Formik
      initialValues={{
        categoryId: initialCategory,
        search: initialSearch,
      }}
      onSubmit={(values) => {
        const { categoryId, search } = values;
        const basePath = categoryId === '1' ? '/shop' : `/shop/${categoryId}`;
        const searchQuery = search ? `?search=${encodeURIComponent(search)}` : '';
        
        navigate(`${basePath}${searchQuery}`);
      }}
    >
      {({ values }) => (
        <Form className="w-100 d-flex justify-content-between h-100">
          <Field 
            as="select" 
            name="categoryId" 
            className="h-50 js-example-basic-single border border-gray-200 border-end-0"
          >
            <option value="1">All Categories</option>
            {categories.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </Field>
          
          <div className="search-form__wrapper position-relative h-100">
            <Field
              type="text"
              name="search"
              className="search-form__input common-input py-13 ps-16 pe-18 rounded-end-pill pe-44"
              placeholder="Search for a product or brand"
            />
            <button
              type="submit"
              className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </Form>
      )}
    </Formik>
    </div>
            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <button
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>
                 
                <Link to="/cart" className="flex-align gap-4 item-hover m-50">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    {cartCount > 0 && (
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {cartCount}
                      </span>
                    )}
                  </span>
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                    Cart
                  </span>
                </Link>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header
        className={`header bg-white border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      >
        <div className="container container-lg">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}
              <div className="category on-hover-item">
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-heading"
                >
                  <span className="icon text-2xl d-xs-flex d-none">
                    <i className="ph ph-dots-nine" />
                  </span>
                  <span className="d-sm-flex d-none">All</span> Categories
                  <span className="arrow-icon text-xl d-flex">
                    <i className="ph ph-caret-down" />
                  </span>
                </button>
                <div
                  className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper ${
                    activeCategory && "active"
                  }`}
                >
                  <button
                    onClick={() => {
                      handleCategoryToggle();
                      setActiveIndexCat(null);
                    }}
                    type="button"
                    className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                  >
                    {" "}
                    <i className="ph ph-x" />{" "}
                  </button>
                  {/* Logo Start */}
                  <div className="logo px-16 d-lg-none d-block">
                    <Link to="/" className="link">
                      <img src="https://i.ibb.co/VtYZ856/logo.png" alt="Logo" />
                    </Link>
                  </div>
                  {/* Logo End */}
                  <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                    {categoriesWithSub.map((item) => (
                      <>
                        <li
                          onClick={() => handleCatClick(0)}
                          className={`has-submenus-submenu ${
                            activeIndexCat === 0 ? "active" : ""
                          }`}
                        >
                          <Link
                            onClick={() => setActiveIndexCat(null)}
                            to={
                              item.subcategory.length > 0
                                ? undefined
                                : `/category/${item.id}`
                            }
                            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                          >
                            <span>{item.name}</span>
                            <span className="icon text-md d-flex ms-auto">
                              {item.subcategory.length > 0 ? (
                                <i className="ph ph-caret-right" />
                              ) : (
                                <></>
                              )}
                            </span>
                          </Link>
                          <div
                            className={`submenus-submenu py-16 ${
                              activeIndexCat === 0 ? "open" : ""
                            }`}
                          >
                            <h6 className="text-lg px-16 submenus-submenu__title">
                              {item.name}
                            </h6>
                            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                              {item.subcategory.map((item) => {
                                return (
                                  <li>
                                    <Link to="/shop">{item.name}</Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </li>
                      </>
                    ))}
                  </ul>
                </div>
              </div>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {/* Nav Menu Start */}
                <ul className="nav-menu flex-align ">
                  <li className="on-hover-item nav-menu__item">
                    <Link to="#" className="nav-menu__link">
                      Home
                    </Link>
                  </li>
                  <li className="on-hover-item nav-menu__item">
                    <Link to="#" className="nav-menu__link">
                      Featured
                    </Link>
                  </li>

                  {categories.map((item) => (
                    <li className="on-hover-item nav-menu__item" key={item.id}>
                      <Link to={`/category/${item.id}`} className="nav-menu__link">
                        {item.name}
                      </Link>
                    </li>
                  ))}

                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div className="header-right flex-align">
              <Link
                to="/tel:01234567890"
                className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
              >
                <div className="d-flex text-32">
                  <i className="ph ph-phone-call" />
                </div>
                +977 980-1188263
              </Link>
              <div className="me-16 d-lg-none d-block">
                <div className="flex-align flex-wrap gap-12">
                  <button
                    onClick={handleSearchToggle}
                    type="button"
                    className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                      <i className="ph ph-magnifying-glass" />
                    </span>
                  </button>
                  <Link to="/cart" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        2
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Wishlist
                    </span>
                  </Link>
                  <Link to="/cart" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        2
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Cart
                    </span>
                  </Link>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type="button"
                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
              >
                {" "}
                <i className="ph ph-list" />{" "}
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderOne;
